import { z } from 'zod';
import { Address, AddressSchema } from '@40seas/models';
import { FromSchema } from '@40seas/entities/common';

export const AiprizeCompanySearchQuerySchema = z.object({
    legalName: z.string(),
    address: AddressSchema,
    dba: z.array(z.string().min(1)).nullish(),
    website: z.string().nullish(),
    phone: z.string().nullish(),
});

export class AiprizeCompanySearchQuery extends FromSchema(AiprizeCompanySearchQuerySchema) {
    legalName: string;
    address?: Address;
    dba?: string[];
    website?: string;
    phone?: string;
}
